import type { useAuth } from '@/hooks/useAuth';

/**
 * Resolves the current org id from the auth user, used as the per-org cache key
 * for billing queries. Lives in its own module so both useBilling and
 * useOnboarding can import it without a circular dependency.
 */
export const getOrganizationId = (user: ReturnType<typeof useAuth>['user']) => {
  const organization = user?.organization;

  if (organization && typeof organization === 'object') {
    return String(organization.id);
  }

  if (organization !== null && organization !== undefined) {
    return String(organization);
  }

  return undefined;
};
